/* RESPONSIBLE TEAM: team-proactive-support */
interface GridSettings {
  spacing: number;
  width: number;
  height: number;
}

interface OptionalGridSettings {
  spacing?: number;
  width?: number;
  height?: number;
}

const DEFAULT_GRID_SETTINGS: GridSettings = {
  spacing: 25,
  width: 6000,
  height: 4000,
};

export { GridSettings, OptionalGridSettings, DEFAULT_GRID_SETTINGS };
